import { BorderType, PaddingType } from 'common/types/styleTypes'
import {
  backgroundColorCss,
  borderCss,
  FontProps,
  fontCss,
  mobileBackgroundColorCss,
  mobileBorderCss,
  mobileFontCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

type BlogPostContentTableUiProps = {
  backgroundColor?: string
  mobileBackgroundColor?: string
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  border: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
} & FontProps

const ContentTableUi = styled.div<BlogPostContentTableUiProps>`
  ${backgroundColorCss}
  ${paddingsCss}
  ${fontCss}
  ${borderCss}
  ${p => p.theme.phone} {
    ${mobileBackgroundColorCss}
    ${mobilePaddingsCss}
    ${mobileBorderCss}
    ${mobileFontCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileBackgroundColorCss}
      ${mobilePaddingsCss}
      ${mobileBorderCss}
      ${mobileFontCss}
    `}
`

export default ContentTableUi
